import { Button, Modal as BootstrapModal } from "react-bootstrap";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import TextBox from "../form/TextBox";
import { useTranslation } from "react-i18next";
import { useCallback } from "react";

const CreateModal = ({ show, heading, validationRegex, onCreate, onCancel }) => {
    const [translate] = useTranslation();

    const create = useCallback(async ({ name }) => {
        onCreate(name);
    }, [onCreate]);

    return (
        <BootstrapModal show={show} backdrop="static">
            <Formik initialValues={{
                name: "",
            }} validationSchema={Yup.object({
                name: Yup.string().matches(validationRegex, translate("OTM_INVALID_NAME")).required(" ")
            })} onSubmit={create}>
                <Form>
                    <BootstrapModal.Header className="h5 text-secondary">{translate(heading)}</BootstrapModal.Header>
                    <BootstrapModal.Body>
                        <TextBox label={translate("OTM_NAME")} type="text" name="name" />
                    </BootstrapModal.Body>
                    <BootstrapModal.Footer>
                        <Button type="submit" className="btn-sm">{translate("OTM_CREATE")}</Button>
                        <Button onClick={onCancel} variant="secondary" className="btn-sm">{translate("OTM_CANCEL")}</Button>
                    </BootstrapModal.Footer>
                </Form>
            </Formik>
        </BootstrapModal>
    );
};

export default CreateModal;
